import React from 'react';
import { Link } from "react-router-dom";
import { Languages } from '../components/languages';

import { withRouter } from 'react-router-dom';


 class MainMenu extends React.Component {
    constructor(props) {
        super(props);

        this.uc = JSON.parse(sessionStorage.getItem("userContext"));
        this.leUserProfile = Languages.getSection('UserProfile');//UserProfile[Languages.selectedLanguage];
        this.state = {
            toggleState: 'normal',
            showSubMenu: false,
            showSubNestedMenu: false,
            selection: props.selection
        };
        this.itemClick = this.itemClick.bind(this);
        this.toggleSubNestedMenu = this.toggleSubNestedMenu.bind(this);
        this.toggleMenu = this.toggleMenu.bind(this);
        this.closeSubMenu = this.closeSubMenu.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location.pathname !== this.props.location.pathname) {
          // Route has changed, update the active link in your state or perform other actions
          // For example, assuming you have an "activeLink" state in your Menu component:
          const currentPathname = this.props.location.pathname;
          if(currentPathname.includes('orders')) {
            this.setState({
                selection: 3,
                showSubMenu: false
            });
          } else if(currentPathname.includes('tracking')) {
            this.setState({
                selection: 4,
                showSubMenu: false
            });
          }else if(currentPathname.includes('giacenze')) {
            this.setState({
                selection: 5,
                showSubMenu: false
            });
          }else if(currentPathname.includes('contrassegni')) {
            this.setState({
                selection: 6,
                showSubMenu: false
            });
          }
          
        }
      }

    toggleSubNestedMenu() {
        this.setState((prevState) => {
            return {
                showSubNestedMenu: !prevState.showSubNestedMenu
            }
        })
    }

    itemClick(ev, itemId, subItemId) {
        if (!this.props.checks(ev)) {
            ev.preventDefault();
            return;
        }
        if (this.state.selection == itemId && this.state.showSubMenu) {
            this.setState({
                selection: itemId,
                showSubMenu: false
            });
        }
        else {
            this.setState({
                selection: itemId,
                showSubMenu: subItemId == null
            });
        }
    }

    toggleMenu() {
        this.setState({ toggleState: this.state.toggleState == 'tight' ? 'normal' : 'tight' });
    }

    closeSubMenu() {
        this.setState({ showSubMenu: false });
    }

    render() {
        var stsecs = this.props.sections.slice();
        /*console.log("menu.render: sections = ", stsecs);
        console.log("menu.render: selection(prop) = ", this.props.selection);
        console.log("menu.render: selection(state) = ", this.state.selection);
        console.log("menu.render: reset = ", this.props.reset);*/
        var itemSeq = 0;

        let sectionElements = [];
        let visibleSubsElements = [];
        let selection = /*this.props.selection || */this.state.selection;

        for (let sct = 0; sct < stsecs.length; sct++) {
            let section = stsecs[sct];
            if (section.show && !section.show()) {
                continue;
            }

            let sectionItems = []; 
            if (section.title)
                sectionItems.push(
                    <div className="menu-section-title" style={{ display: section.title ? 'block' : 'none' }} key={"sect-t-" + sectionItems.length}>{section.title}</div>
                );

            for (let it = 0; it < section.items.length; it++) {
                let item = section.items[it];

                if (item.show && !item.show()) {
                    continue;
                }

                let content;
                let itemId = itemSeq++
                let active = selection == itemId;

                if (item.className == 'menu-user') {
                    // patch user name
                    item.title = (this.uc.firstName ? this.uc.firstName + " " : "") + this.uc.lastName;
                }

                if (item.action) {
                    content = <Link to={item.action} onClick={(e) => this.itemClick(e, itemId)} className="menu-content">
                        <div className="menu-icon" style={{ backgroundImage: 'url(' + item.icon + ')' }} />
                        <div className="menu-label ellipsis">{item.title}</div>
                    </Link>;
                } else {
                    content = <div className="menu-content link" onClick={(e) => this.itemClick(e, itemId)}>
                        <div className="menu-icon" style={{ backgroundImage: 'url(' + item.icon + ')' }} />
                        <div className="menu-label ellipsis">{item.title}</div>
                    </div>;
                }

                let current = item.action == window.location.pathname;
                if (!current && item.subs) {
                    current = item.subs.filter(el => (el.action == window.location.pathname)).length > 0;
                }

               
                if (active && item.subs && item.subs.length) {
                    // show subitems

                    if(item.subs.length == 7){
                        item.subs.sort(function(a, b) {
                            var textA = a.action;
                            var textB = b.action;
                            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                        });
                     }
                    for (let sit = 0; sit < item.subs.length; sit++) {    

                        if (item.subs[sit].show && !item.subs[sit].show()) {
                            continue;
                        }
                        let nestedSubContentMenu = [];
                        let subMenuItem
                        if(item.subs[sit].subs) {
                            nestedSubContentMenu = item.subs[sit].subs.map((item, index) => {
                                let currentNestedActiveRoute = item.action === window.location.pathname ? "active": "";
                                return  <div key={itemId + "-"  + sit + "-" + index} className={`sub-nested-menu-item ${currentNestedActiveRoute}`} data-item-id={"sub-menu- " + itemId} data-sub-item-id={"sub-item-id" + sit}>
                                    <Link to={item.action}  className="menu-nested-sub-content" onClick={(e) => this.itemClick(e, itemId)}>
                                        <div className="menu-nested-sub-label ellipsis">{item.title}</div>
                                    </Link>
                                </div>;
                            })
                        }

                        let subMenuItemClass = nestedSubContentMenu.length > 0 ? "sub-menu-item has-nested-sub-menu": "sub-menu-item";
                        let isSubNestedNemuActive = nestedSubContentMenu.length > 0 && this.state.showSubNestedMenu ? "active": ""
                       
                        subMenuItem = <div key={itemId + "-" + sit} className={subMenuItemClass + " " + isSubNestedNemuActive} data-item-id={itemId} data-sub-item-id={sit}>
                            {nestedSubContentMenu.length === 0 ? 
                            <Link to={item.subs[sit].action} onClick={(e) => this.itemClick(e, itemId, sit)} 
                                className="menu-content">
                                <div className="menu-label ellipsis">
                                    <span>{item.subs[sit].title}</span>
                                    {nestedSubContentMenu.length > 0 && <div style={this.state.showSubNestedMenu ? {display: "block", backgroundColor: "white"}: {display: "none", backgroundColor: "transparent"}}>
                                        {nestedSubContentMenu.map((item, index) => {
                                            return <div key={index}>{item}</div>;
                                        })}
                                    </div>}
                                </div>
                            </Link>: <>                            
                                <div onClick={(e) => this.toggleSubNestedMenu()} className="menu-label ellipsis">
                                <span>{item.subs[sit].title}</span>
                                    {nestedSubContentMenu.length > 0 && <div style={this.state.showSubNestedMenu ? {display: "block", backgroundColor: "white"}: {display: "none", backgroundColor: "transparent"}}>
                                        {nestedSubContentMenu.map((item, index) => {
                                            return item
                                        })}
                                    </div>}
                                </div></>
                            }
                        </div>;

                        visibleSubsElements.push(subMenuItem);
                    }
                }

                sectionItems.push(<div className={(active ? 'active ' : '') + (item.className ? item.className : '') + " menu-item "} data-item-id={itemId} key={itemId}>
                    {content}
                </div>);
            }

            sectionElements.push(<div className="menu-section" key={'sect-' + sectionElements.length} >
                {sectionItems}
            </div>);

        }

        return (
            <div className="menu-container">
                <div className={this.state.toggleState + " menu-panel"} data-level="0">
                    <div className="menu-title"></div>
                    <div className="menu-toggle" onClick={this.toggleMenu}></div>
                    {sectionElements}
                </div>
                <div className={"sub-menu-panel " + (this.state.showSubMenu && visibleSubsElements.length > 0 ? 'visible' : 'hidden')}>
                    <div className="menu-title">
                        <div className="sub-menu-close" onClick={this.closeSubMenu} />
                    </div>
                    {visibleSubsElements}
                </div>
            </div>
        );

    }

}


export default withRouter(MainMenu);